import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizzActions, QuizzActionTypes } from './quizz.actions';
import { Quizz, QuizzResponse } from './quizz.models';

interface QuizzState {
  quizz: Quizz;
  quizzResponse: QuizzResponse;
  leaveQuizz: boolean;
}

export const quizzInitialState: QuizzState = {
  quizz: undefined,
  quizzResponse: undefined,
  leaveQuizz: false
};

export function quizzReducer(
  state = quizzInitialState,
  action: QuizzActions
): QuizzState {
  switch (action.type) {
    case QuizzActionTypes.LOAD_QUIZZ:
      return {
        ...state,
        quizz: void 0,
        quizzResponse: void 0
      };

    case QuizzActionTypes.LOAD_QUIZZ_SUCCESS:
      return {
        ...state,
        quizz: action.payload
      };

    case QuizzActionTypes.SAVE_QUIZZ_SUCCESS:
      return { ...state, quizzResponse: action.payload };

    case QuizzActionTypes.QUIZZ_LEFT:
      return { ...state, leaveQuizz: false };

    case QuizzActionTypes.REDO_QUIZZ:
      return { ...state, quizz: void 0, leaveQuizz: false };

    case QuizzActionTypes.LEAVE_QUIZZ:
      return { ...state, quizz: void 0, leaveQuizz: true };

    default:
      return state;
  }
}

const quizzState = createFeatureSelector<QuizzState>('quizz');

export const selectorQuizzQuizz = createSelector(
  quizzState,
  state => state.quizz
);

export const selectorQuizzQuizzResponse = createSelector(
  quizzState,
  state => state.quizzResponse
);

export const selectorQuizzLeaveQuizz = createSelector(
  quizzState,
  state => state.leaveQuizz
);
